/**
 * API Danh sách Thẩm phán (cho Chánh án phân công) – POC mock.
 */
import { apiSlice } from './apiSlice'

export interface JudgeOption {
  id: string
  name: string
  workload: number
}

export const judgesApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getJudges: builder.query<JudgeOption[], void>({
      query: () => ({ url: 'judges', method: 'GET' }),
      providesTags: ['Judges'],
    }),
  }),
})

export const { useGetJudgesQuery } = judgesApi
